module.exports = __webpack_public_path__ + "static/1-cad2c7386b7f8826e6bf59c5ab142689.jpg";